var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-text",
        {
          staticClass: "pa-3"
        },
        [
          _c(
            "h2",
            {
              staticClass: "kvm-ip__title body-1 d-flex align-center mb-3"
            },
            [
              _c(
                "v-icon",
                {
                  staticClass: "mr-2",
                  attrs: {
                    size: "24",
                    color: "primary",
                    "aria-hidden": "true"
                  }
                },
                [_vm._v("mdi-ip-network")]
              ),
              _vm._v(" IP Addresses ")
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "kvm-ip__table"
            },
            [
              _c("v-simple-table", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function fn() {
                      return [
                        _c(
                          "caption",
                          {
                            staticClass: "kvm-ip__caption"
                          },
                          [_vm._v("IP addresses assigned to this server")]
                        ),
                        _c("thead", [
                          _c("tr", [
                            _c(
                              "th",
                              {
                                staticClass: "text-left",
                                attrs: {
                                  scope: "col"
                                }
                              },
                              [_vm._v("IP Address")]
                            ),
                            _c(
                              "th",
                              {
                                staticClass: "text-left",
                                attrs: {
                                  scope: "col"
                                }
                              },
                              [_vm._v("Type")]
                            ),
                            _c(
                              "th",
                              {
                                staticClass: "text-left",
                                attrs: {
                                  scope: "col"
                                }
                              },
                              [_vm._v("Assignment")]
                            )
                          ])
                        ]),
                        _c(
                          "tbody",
                          [
                            _vm._l(_vm.ipList, function(ip, i) {
                              return _c(
                                "tr",
                                {
                                  key: ip
                                },
                                [
                                  _c(
                                    "td",
                                    {
                                      attrs: {
                                        "data-label": "IP Address"
                                      }
                                    },
                                    [
                                      _c("kvm-copyable", {
                                        attrs: {
                                          value: ip
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "td",
                                    {
                                      attrs: {
                                        "data-label": "Type"
                                      }
                                    },
                                    [_vm._v("IPv4")]
                                  ),
                                  _c(
                                    "td",
                                    {
                                      attrs: {
                                        "data-label": "Assignment"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          i === 0 ? "Primary" : "Additional"
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            }),
                            !_vm.ipList.length
                              ? _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text-center kvm-ip__empty",
                                      attrs: {
                                        colspan: "3"
                                      }
                                    },
                                    [_vm._v("No IP addresses assigned yet.")]
                                  )
                                ])
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "kvm-ip__request mt-4"
            },
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    small: "",
                    tile: "",
                    color: "primary",
                    disabled: "",
                    "aria-describedby": "kvm-ip-request-note"
                  }
                },
                [
                  _c(
                    "v-icon",
                    {
                      attrs: {
                        left: "",
                        small: "",
                        "aria-hidden": "true"
                      }
                    },
                    [_vm._v("mdi-plus")]
                  ),
                  _vm._v("Request IP ")
                ],
                1
              ),
              _c(
                "p",
                {
                  staticClass: "kvm-ip__note mt-2 mb-0",
                  attrs: {
                    id: "kvm-ip-request-note"
                  }
                },
                [
                  _vm._v(
                    " Requesting additional IP addresses isn't available yet. "
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }